export default __webpack_public_path__ + "static/media/question_04.e8a31055.png";